import { FunctionComponent } from 'react'
import { IconButton, TooltipWrapper } from '../../shared'
import { TooltipIconButtonProps } from './TooltipIconButton.model'

const TOOLTIP_SHOW_DELAY_MS = 500

/**
 * IconButton sans bordure avec info-bulle au style de l'app (le title natif ne l'est pas).
 * Petit délai d'apparition : pas de bulle au simple passage de la souris.
 * Le wrapper div sert d'ancre à Tippy (IconButton ne forwarde pas de ref).
 */
export const TooltipIconButton: FunctionComponent<TooltipIconButtonProps> = ({
  label,
  pointerDirection = 'top',
  ...iconButtonProps
}) => (
  <TooltipWrapper
    content={label}
    pointerDirection={pointerDirection}
    size="small"
    showDelay={TOOLTIP_SHOW_DELAY_MS}
  >
    <div>
      <IconButton theme="transparent-dark" size="nano" noBorder {...iconButtonProps} />
    </div>
  </TooltipWrapper>
)
